import * as React from "react";

const styles = require("./equalizer.scss");

const Equalizer = ({ active }: { active?: boolean }) => {
  return (
    <div
      className={`${styles.equalizer} ${
        active ? styles.active : styles.static
      }`}
    >
      <span className={styles.bar_1} />
      <span className={styles.bar_2} />
      <span className={styles.bar_3} />
    </div>
  );
};

export default Equalizer;
